import { useEffect, useState, useCallback } from 'react'
import { informesApi } from '../../api/informes'
import { colors, font } from '../../design/tokens'
import { Cargando, ErrorMsg, Titulo, TabsSegmento, Seccion } from './comunes'

// Tablero de entregas en el celular (Martin, 31 ago 2026): los mismos números
// que LOGÍSTICA → Tablero (/informes), en formato de bolsillo y solo lectura.
const RANGOS = [
  { k: 7, label: '7 días' },
  { k: 30, label: '30 días' },
  { k: 90, label: '90 días' },
]

const iso = (d) => d.toISOString().slice(0, 10)

export default function MovilTablero() {
  const [dias, setDias] = useState(7)
  const [datos, setDatos] = useState(null)
  const [error, setError] = useState(null)

  const cargar = useCallback(async () => {
    setDatos(null)
    try {
      const desde = new Date(); desde.setDate(desde.getDate() - (dias - 1))
      const { data } = await informesApi.entregas({ fecha_desde: iso(desde), fecha_hasta: iso(new Date()) })
      setDatos(data)
      setError(null)
    } catch (e) {
      setError(e.response?.data?.message || 'No se pudo cargar el tablero')
    }
  }, [dias])

  useEffect(() => { cargar() }, [cargar])

  const r = datos?.resumen

  return (
    <div>
      <Titulo>Tablero de entregas</Titulo>
      <TabsSegmento options={RANGOS} value={dias} onChange={setDias} />
      {error && <ErrorMsg>{error}</ErrorMsg>}
      {!datos && !error && <Cargando />}

      {r && (
        <>
          <div style={kpis}>
            <Kpi n={r.entregados} label="entregados" color="#16a34a" />
            <Kpi n={r.no_entregados} label="no entreg." color={colors.err} />
            <Kpi n={r.reagendados} label="reagend." color="#d97706" />
            <Kpi n={r.pendientes} label="pendientes" color={colors.textSec} />
          </div>
          <div style={tasa}>
            Tasa de éxito <b style={{ fontFamily: font.mono }}>{r.tasa_exito}%</b>
            <span style={{ color: colors.textMeta }}> · {datos.salidas?.despachada ?? 0} salidas en la calle · {datos.salidas?.cerrada ?? 0} cerradas</span>
          </div>
        </>
      )}

      {datos?.por_fletero?.length > 0 && (
        <Seccion titulo="Por fletero">
          {datos.por_fletero.map((f) => (
            <div key={f.id} style={fila}>
              <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.nombre}</span>
              <span style={{ fontFamily: font.mono, color: '#16a34a' }}>{f.entregados}✓</span>
              {f.no_entregados > 0 && <span style={{ fontFamily: font.mono, color: colors.err }}>{f.no_entregados}✕</span>}
              {f.pendientes > 0 && <span style={{ fontFamily: font.mono, color: colors.textSec }}>{f.pendientes}·</span>}
              <span style={{ fontFamily: font.mono, color: colors.textSec, width: 52, textAlign: 'right' }}>{f.tasa_exito}%</span>
            </div>
          ))}
        </Seccion>
      )}

      {datos?.por_motivo?.length > 0 && (
        <Seccion titulo="Motivos de no entrega">
          {datos.por_motivo.map((m, i) => (
            <div key={i} style={fila}>
              <span style={{ flex: 1 }}>{m.motivo}</span>
              <span style={{ fontFamily: font.mono, color: colors.err }}>{m.n}</span>
            </div>
          ))}
        </Seccion>
      )}

      {datos?.detalle_no_entregados?.length > 0 && (
        <Seccion titulo={`Sin resolver (${datos.detalle_no_entregados.length})`}>
          {datos.detalle_no_entregados.slice(0, 15).map((d, i) => (
            <div key={i} style={{ padding: '7px 0', borderBottom: `1px solid ${colors.borderSoft}` }}>
              <div style={{ fontFamily: font.sans, fontWeight: 600, fontSize: 13.5, color: colors.text }}>{d.cliente || 'Sin nombre'}</div>
              <div style={{ fontSize: 12, color: colors.textSec, fontFamily: font.sans }}>{d.direccion || ''}</div>
              <div style={{ fontSize: 12, color: colors.err, fontFamily: font.sans, marginTop: 1 }}>{d.motivo || d.estado_mostrado || ''}</div>
            </div>
          ))}
        </Seccion>
      )}
    </div>
  )
}

function Kpi({ n, label, color }) {
  return (
    <div style={{ flex: 1, textAlign: 'center', padding: '10px 4px', border: `1px solid ${colors.border}`, borderRadius: 12, background: colors.bg }}>
      <div style={{ fontFamily: font.mono, fontVariantNumeric: 'tabular-nums', fontSize: 20, fontWeight: 700, color }}>{n}</div>
      <div style={{ fontSize: 10.5, color: colors.textSec, fontFamily: font.sans, textTransform: 'uppercase', letterSpacing: '0.03em' }}>{label}</div>
    </div>
  )
}

const kpis = { display: 'flex', gap: 6, margin: '12px 0 8px' }
const tasa = { fontSize: 13, fontFamily: font.sans, color: colors.text, margin: '0 0 6px' }
const fila = { display: 'flex', gap: 8, alignItems: 'baseline', padding: '6px 0', fontSize: 13.5, fontFamily: font.sans, color: colors.text, borderBottom: `1px solid ${colors.borderSoft}` }
